import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";
import { useState } from "react";

const DeleteAlert = ({
  isOpen,
  onClose,
  onDelete,
  label = "Delete",
  itemName = "",
}) => {
  const [isLoading, setLoading] = useState(false);

  const onProceed = async () => {
    setLoading(true);

    try {
      await onDelete();
      onClose();
    } catch (error) {
      // Error handling is done in the delete function
    }

    setLoading(false);
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      leastDestructiveRef={undefined}
    >
      <AlertDialogOverlay bg="rgba(0, 0, 0, 0.4)" backdropFilter="blur(4px)">
        <AlertDialogContent
          borderRadius="lg"
          boxShadow="0 20px 25px -5px rgba(0, 0, 0, 0.2)"
        >
          <Box p={6}>
            <Box display="flex" alignItems="center" gap={3} mb={4}>
              <Box
                p={3}
                borderRadius="full"
                bg="red.50"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon as={FiTrash2} color="red.600" w={5} h={5} />
              </Box>
              <AlertDialogHeader p={0} fontSize="xl" fontWeight="bold">
                Delete {label}?
              </AlertDialogHeader>
            </Box>

            <AlertDialogBody p={0} color="gray.600">
              <Text>
                Are you sure you want to delete this {label.toLowerCase()}? This
                action cannot be undone.
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter gap={3} pt={6}>
              <Button
                variant="ghost"
                onClick={onClose}
                px={6}
                _hover={{ bg: "gray.100" }}
                isDisabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                isLoading={isLoading}
                loadingText="Deleting..."
                colorScheme="red"
                px={6}
                onClick={onProceed}
                bg="red.600"
                _hover={{ bg: "red.700" }}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </Box>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export { DeleteAlert };
